import React from "react";
import CustomerComment from "./CustomerComment";
import InternalNote from "./InternalNote";
import AutomaticLog from "./AutomaticLog";

function OrderActivities({classes, notes, lineItemActivities, order}) {
    let items = [...(notes || [])];
    if (lineItemActivities) {
        items = items.concat(lineItemActivities);
    }

    items.sort((itemA, itemB) => {
        let dateA = Date.parse(itemA.createdAt), dateB = Date.parse(itemB.createdAt);
        return (dateA < dateB) - (dateA > dateB);
    });

    const categories = {
        customer_comment: [],
        internal_note: [],
        automatic: [],
    };

    items.forEach((item) => {
        if (item['@type'] === 'LineItemActivity') {
            categories.automatic.push(item);
        } else if (item['@type'] === 'Note') {
            const noteType = item.noteType || 'automatic';
            if (categories[noteType]) {
                categories[noteType].push(item);
            } else {
                categories.internal_note.push(item);
            }
        }
    });

    const customerComment = categories.customer_comment[0] || null;

    return (
        <>
            {customerComment &&
                <CustomerComment item={customerComment} order={order} />
            }
            {categories.internal_note.length > 0 &&
                <InternalNote items={categories.internal_note} order={order} />
            }
            {categories.automatic.length > 0 &&
                <div className={classes.noteCategorySection}>
                    {categories.automatic.map((item, key) => (
                        <AutomaticLog key={key} item={item} order={order} />
                    ))}
                </div>
            }
        </>
    );
}

export default OrderActivities;
